(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.tipsinfo.tableComponents,
  TableBody = _svs$components$tipse.TableBody,
  TableHeader = _svs$components$tipse.TableHeader;
const TableComponent = _ref => {
  let ariaDescription = _ref.ariaDescription,
    branding = _ref.branding,
    children = _ref.children,
    className = _ref.className;
  return React.createElement("table", {
    className: clx('tipsinfo_table', className, {
      ["tipsinfo_table--".concat(branding)]: branding
    })
  }, ariaDescription && React.createElement("caption", {
    className: "sr-only"
  }, ariaDescription), children);
};
TableComponent.Body = TableBody;
TableComponent.Header = TableHeader;
setGlobal('svs.components.tipsen.tipsinfo.tableComponents.TableComponent', TableComponent);

 })(window);